import React from 'react'
import { Link } from 'react-router-dom'
import style from './RedirectQuestaGlobal.module.css'
export default function RedirectQuestaGlobal() {
  return (
    <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',height:'100vh'}}>


<div className={style.card}>
<h3>Questa Has A New Main Website!</h3>
<img src='https://questa-global.com/assets/images/logo-black.png' width={180}/>
<p>
    
    
    <br/>
    <h6>www.questa-global.com</h6>
    <a href='https://www.questa-global.com' className={style.b1}>Go to new Version</a></p>
    
or
<br/>
<img className='logo' src="/assets/img/logo/questa logo.png" width={180} alt="img not found"/>
<h6>www.questa.education</h6>
<p><Link to='home'  className={style.b2}>Continue to HomePage</Link></p>


</div>
    </div>
  )
}
